module.exports = __webpack_public_path__ + "7d858433cbfbfa0ff377feaa502d9cad.png";